import { render, staticRenderFns } from "./BetslipBox.vue?vue&type=template&id=21679dd2&"
import script from "./BetslipBox.vue?vue&type=script&lang=js&"
export * from "./BetslipBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports